var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFemale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 951.426,
    height: 1734.68,
    viewBox: "0 0 951.426 1734.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 336.382,
    cy: 336.384,
    rx: 336.382,
    ry: 336.384,
    transform: "translate(1305.592 608.775) rotate(-45)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_119",
    "data-name": "Group 119",
    transform: "translate(-1305.592 -133.063)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_932",
    "data-name": "Path 932",
    d: "M1781.32,188.809c-231.562,0-419.955,188.393-419.955,419.957s188.393,419.955,419.955,419.955,419.96-188.391,419.96-419.955S2012.89,188.809,1781.32,188.809Zm0,756.339c-185.482,0-336.382-150.9-336.382-336.382s150.9-336.384,336.382-336.384,336.387,150.9,336.387,336.384S1966.81,945.148,1781.32,945.148Z",
    fill: "#f35071"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_933",
    "data-name": "Path 933",
    d: "M1781.32,1113.99c-137.229,0-248.475,111.246-248.475,248.475,0,126.567,94.655,230.955,217.024,246.424v77.38H1695.56a39.711,39.711,0,0,0,0,79.422h54.309v62.342a39.71,39.71,0,0,0,79.42,0v-62.342H1883.6a39.711,39.711,0,0,0,0-79.422h-54.309v-80c114.267-22.356,200.505-122.989,200.505-243.8C2029.8,1225.23,1918.55,1113.99,1781.32,1113.99Zm0,424.17a175.7,175.7,0,1,1,175.7-175.7A175.7,175.7,0,0,1,1781.32,1538.16Z",
    fill: "#f35071"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_118",
    "data-name": "Group 118"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_117",
    "data-name": "Group 117",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_934",
    "data-name": "Path 934",
    d: "M1786.15,373.082s97.234-19.321,153.106,63.017,15.655,149.82,12.724,189.334c-5.453,73.516,19.029,74.722,18.562,142.391-.246,35.639-43.313,122.692-43.313,122.692l-150.568-14.755Z",
    fill: "#4a301e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_935",
    "data-name": "Path 935",
    d: "M1725.52,808.317c67.771,128.816,96.955,17.415,111.6,0V761.61h-111.6Z",
    fill: "#dba465"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_936",
    "data-name": "Path 936",
    d: "M1619.52,593.1l6.551,50.57c1.272,9.815,11.248,17.587,23,17.92h0l-12.232-70.8-5.681-3.244C1625.77,584.468,1618.83,587.781,1619.52,593.1Z",
    fill: "#f0b976"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_937",
    "data-name": "Path 937",
    d: "M1917.04,549.6c-10.454-96.986-56.137-160.59-140.282-160.59s-129.828,63.6-140.283,160.59c-.9,8.322-.535,34.343-.559,42.956-.062,21.876,8.06,59.66,12.3,76.274,2.56,10.04,52.411,114.88,128.546,114.88s125.985-104.841,128.545-114.88c4.236-16.614,12.359-54.4,12.3-76.274C1917.58,583.945,1917.94,557.925,1917.04,549.6Z",
    fill: "#f0b976"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_938",
    "data-name": "Path 938",
    d: "M1803.23,462.868s-103.822-6.6-117.509,84c-13.455,89.063-19.959,86.594-48.757,134.126s1.464,63.9,1.464,63.9l-24.892-16.309,20.6-186.262,33.476-132.186,135.619-35.192v87.921Z",
    fill: "#4a301e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_939",
    "data-name": "Path 939",
    d: "M1794.76,462.868s109.491,9.279,122.845,129.691l11.042-31.568-14.678-131.237-94.335-54.806H1794.76Z",
    fill: "#4a301e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_940",
    "data-name": "Path 940",
    d: "M1922.17,585.282l-4.508,1.9-13.406,72.147c11.754-.333,21.731-8.1,23-17.92l6.551-50.57C1934.49,585.518,1927.56,582.205,1922.17,585.282Z",
    fill: "#f0b976"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_941",
    "data-name": "Path 941",
    d: "M1871.73,790.7h-34.611s-51.584,47.488-111.6,0h-47.142q-2.353,0-4.692.054c-89.638,2.069-160.647,76.643-160.647,166.3v52.631l536.561-5.515V958.9c0-72.241-46.3-137.194-115.354-158.412A217.682,217.682,0,0,0,1871.73,790.7Z",
    fill: "#c7304e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_942",
    "data-name": "Path 942",
    d: "M1786.15,373.082s-172.61-34.716-183.471,156.5c-.566,9.968.882,19.948,2.779,29.751,4.387,22.669,12.6,71.205,8.017,96.574-6.1,33.817-39.208,52.43-20.807,147.032,12.136,62.4-9.128,98.191-5.568,121.489,0,0,47.177,45.861,127.88,5.847,27.36-13.565,15.679-32.257,10.994-134.767V767.824s-95.785-66.842-73.553-217.77,133.913-139.123,133.913-139.123Z",
    fill: "#4a301e"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemale);
export default __webpack_public_path__ + "static/media/female.cf76570fd1c5864aac4dd738a153f85e.svg";
export { ForwardRef as ReactComponent };